const UID_LENGTH = 21
const UID_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

export function generateUid (): string {
  const cryptoObj: Crypto | undefined =
    typeof window !== 'undefined' && window.crypto
      ? window.crypto
      : (typeof self !== 'undefined' && self.crypto ? self.crypto : undefined)

  const length = UID_LENGTH
  const chars = UID_CHARS
  const charsLength = chars.length
  let result = ''

  if (cryptoObj && typeof cryptoObj.getRandomValues === 'function') {
    const buffer = new Uint32Array(length)
    cryptoObj.getRandomValues(buffer)
    for (let i = 0; i < length; i++) {
      result += chars[buffer[i] % charsLength]
    }
    return result
  }

  for (let i = 0; i < length; i++) {
    result += chars[Math.floor(Math.random() * charsLength)]
  }
  return result
}
